export function isWhite(color: string) {
  return color.toLowerCase() === '#ffffff'
}

// http://alienryderflex.com/hsp.html
export function getIsLightColor(color: string) {
  const [r, g, b] = hex2Rgb(color)
  const hsp = Math.round((299 * r + 587 * g + 114 * b) / 1e3)
  return hsp >= 180
}

function hex2Rgb(color: string): number[] {
  return (
    color
      .replace('#', '')
      .match(/[a-zA-Z0-9]{2}/g)
      ?.map((c) => parseInt(c, 16)) ?? []
  )
}

export function getRgbColor(color: string) {
  return hex2Rgb(color).join(',')
}
